module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="data-column">\n	<div class="title">Selected Tips</div>\n	<div class="data-column">\n		<div class="value">\n			'+
((__t=( selected_tips_count ))==null?'':_.escape(__t))+
' \n			';
 if(selected_tips_count < total_tips_count ) { 
__p+='\n				<img src="/assets/images/warning.svg" alt="Incorrect Tip Number">\n			';
 }else { 
__p+='\n				<img src="/assets/images/greenCheck.svg" alt="Incorrect Tip Number">\n			';
 } 
__p+='\n		</div>\n		<div class="data-total">\n		/'+
((__t=( total_tips_count ))==null?'':_.escape(__t))+
'\n		</div>\n	</div>\n</div>\n';
}
return __p;
};
